import React from 'react';

export default function CategoryNav({ categories = [], activeCategory, onSelectCategory, productsCountByCat = {} }) {
  return (
    <div className="w-full overflow-x-auto no-scrollbar py-2">
      <div className="flex items-center gap-2 min-w-max pb-1">
        {categories.map((cat) => {
          const isActive = activeCategory === cat.slug || activeCategory === cat.id;
          const count = productsCountByCat[cat.slug] || productsCountByCat[cat.id] || 0;

          return (
            <button
              key={cat.id || cat.slug}
              type="button"
              onClick={() => onSelectCategory(cat.slug || cat.id)}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-xl text-xs sm:text-sm font-bold uppercase tracking-wider transition-all cursor-pointer ${
                isActive
                  ? 'bg-urb-primary text-black shadow-[0_0_15px_rgba(138,230,0,0.3)] font-black'
                  : 'bg-urb-card-light/70 text-urb-text-secondary hover:text-white hover:bg-urb-card-light border border-urb-border hover:border-urb-primary/30'
              }`}
            >
              <span>{cat.name}</span>
              {count > 0 && (
                <span
                  className={`text-[10px] font-black px-1.5 py-0.5 rounded-full ${
                    isActive
                      ? 'bg-black/20 text-black'
                      : 'bg-white/10 text-urb-text-muted'
                  }`}
                >
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
